var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.586 17.288a1.406 1.406 0 0 1-.996 2.4c-.373 0-.73-.146-.996-.408l-7.441-7.442L2.71 19.28a1.418 1.418 0 0 1-1.992 0 1.407 1.407 0 0 1 0-1.992l7.442-7.442L.719 2.405A1.409 1.409 0 1 1 2.711.413l7.442 7.441L17.594.413a1.409 1.409 0 0 1 1.992 1.992l-7.441 7.441 7.441 7.442z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.03badfc056620e7f0237f7ff560318d5.svg";
export { ForwardRef as ReactComponent };